/* unplugin-vue-components disabled */import { render } from "./DeviceOaid.vue?vue&type=template&id=d8f328b4&scoped=true"
import script from "./DeviceOaid.vue?vue&type=script&lang=js"
export * from "./DeviceOaid.vue?vue&type=script&lang=js"

import "./DeviceOaid.vue?vue&type=style&index=0&id=d8f328b4&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/mianjuyry-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8f328b4"]])

export default __exports__